// Чья медкарта сейчас открыта в разделе "Медкарта": своя (по умолчанию) или карта члена
// семьи. Выбор делается на /medCard и живёт в sessionStorage, чтобы его видели и
// подразделы (/medCard/analysisResults и т.д.), и переход по F5/назад.
//
// Хранится { ID, FULL_FIO, CHART_NUMBER } члена семьи из get_registry_persons. В запросы
// уходит только ID (MC_PERSON_ID) - шлюз data сам проверяет, что это член семьи текущего
// пользователя, и подставляет его карту (см. api_lk/edit_lk/P.LK.MC.GET_PERSON_CHART).

const STORAGE_KEY = 'medCardOwner';

export function getMedCardOwner() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const owner = raw ? JSON.parse(raw) : null;
    return owner?.ID ? owner : null;
  } catch {
    return null;
  }
}

export function setMedCardOwner(member) {
  try {
    if (!member?.ID) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ID: member.ID, FULL_FIO: member.FULL_FIO, CHART_NUMBER: member.CHART_NUMBER || null })
    );
  } catch {
    // без sessionStorage просто остаёмся на своей карте
  }
}

export function clearMedCardOwner() {
  setMedCardOwner(null);
}

// Тело запроса к сценариям медкарты: для карты члена семьи добавляет MC_PERSON_ID
export function withMedCardOwner(payload = {}) {
  const owner = getMedCardOwner();
  return owner ? { ...payload, MC_PERSON_ID: owner.ID } : payload;
}

// "Иванов Иван Иванович" -> "Иванов И. И."
export function shortFio(fullFio) {
  const [last, ...rest] = String(fullFio || '').trim().split(/\s+/);
  if (!last) return '';
  return [last, ...rest.map((part) => `${part[0]}.`)].join(' ');
}

// Подпись ссылки "назад" в подразделах медкарты - одинаковая и для своей карты,
// и для карты члена семьи
export function getMedCardBackTitle() {
  return 'Вернуться назад';
}

// Значение параметра ?card= на /medCard: 'self' - своя карта, иначе ID члена семьи.
// Без параметра (и при нескольких картах) /medCard показывает шаг выбора карты.
export const SELF_CARD_PARAM = 'self';

// Адрес "назад" из подразделов - сразу внутрь открытой карты, минуя выбор
export function getMedCardBackUrl() {
  const owner = getMedCardOwner();
  return `/medCard?card=${owner ? encodeURIComponent(owner.ID) : SELF_CARD_PARAM}`;
}
